import React, { useEffect } from 'react';
import { RouterProvider, createBrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@mui/material';
import Box from '@mui/material/Box';
import { Toaster } from 'react-hot-toast';
import routes from './router/routes';
import { useAuth } from './context/AuthContext';
import { theme } from './theme/theme';
import { useAppDispatch, useAppSelector } from './redux/hooks';
import { RootState } from './redux/store';
import LoaderSvg from './assets/img/dot-revolve.svg';
import PermissionDeniedAlertModel from './components/AlertModal/PermissionDeniedAlertModal/PermissionDeniedAlertModel';
import TawkChat from './components/TawkChat/TawkChat';
import { websocketActions } from './redux/webSocket/webSocketSlice';
import BlankLayout from './components/V1/Layouts/BlankLayout/BlankLayout';

function App(): React.JSX.Element {
  const { isLogin, user } = useAuth();
  const { permissions } = user;
  const dispatch = useAppDispatch();
  const role = isLogin ? user.role : '';
  const router = createBrowserRouter(routes(isLogin, role, permissions));

  const { isPageLoading } = useAppSelector((state: RootState) => state.auth.componentStatus);

  useEffect(() => {
    if (isLogin) {
      dispatch(websocketActions.connectWebSocket());
    }
  }, [dispatch, isLogin]);

  return (
    <ThemeProvider theme={theme}>
      {isPageLoading ? (
        <BlankLayout>
          <Box component="img" src={LoaderSvg} role="progressbar" />
        </BlankLayout>
      ) : (
        <>
          <RouterProvider router={router} />
          <PermissionDeniedAlertModel />
          <TawkChat />
        </>
      )}
      <Toaster
        position="bottom-right"
        toastOptions={{
          duration: 5000,
        }}
        containerStyle={{ position: 'fixed', left: '20%', transform: 'translate(-50%, -50%)' }}
      />
    </ThemeProvider>
  );
}

export default App;
